import * as type from './constant';

export const getAgency = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getAgencySuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getAgencyError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addAgency = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addAgencySuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateAgency = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateAgencySuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteAgency = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteAgencySuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationAgencyError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
